<div class="garde-container">
    <div class="calendar-form">
        <div class="selection">
            <div *ngIf="parents && selectedParent" class="select-parent">
                <h4>{{ 'GARDES.PARENTS' | translate }}</h4>
                <div *ngFor="let parent of parents; let i = index" class="parent">
                    <label (click)="!readonly ? (selectedParent = parent) : ''" [ngClass]="{ readonly: readonly }">
                        <span class="badge" [ngClass]="{ '-blue': i === 0, '-pink': i === 1 }"></span>
                        {{ parent.firstname + ' ' + parent.lastname }}
                        <span *ngIf="parent.id === selectedParent.id && !readonly">{{ 'GARDES.SELECTED' | translate }}</span>
                    </label>
                </div>
                <p class="tips" *ngIf="!readonly">*{{ 'GARDES.TIPS' | translate }}</p>
            </div>
            <div class="select-model" *ngIf="!readonly && parents && selectedParent">
                <h4>{{ 'GARDES.MODELE' | translate }}</h4>
                <div *ngIf="periodForm">
                    <app-switch-input
                        [formControl]="periodForModel"
                        [title]="'GARDES.SWITCH_TITLE'"
                        [label]="'GARDES.SWITCH_LABEL'"
                    ></app-switch-input>
                </div>
                <div *ngFor="let model of gardeModels; let i = index" class="form-control">
                    <button (click)="applyGardeModel(model)" class="btn btn--secondary" [disabled]="isLoading">
                        {{ 'GARDES.APPLY' | translate }} {{ 'GARDES.NAME-LABELS.' + model.name | translate }}
                    </button>
                    <app-infobulle [text]="'GARDES.NAME-LABELS.' + model.name | translate">
                        <div class="model-dots">
                            <div class="week" *ngFor="let w of model.pattern">
                                <div
                                    *ngFor="let d of w"
                                    class="badge"
                                    [ngClass]="
                                        (d === 1 && selectedParent.id === parents[0].id) || (d === 2 && selectedParent.id !== parents[0].id)
                                            ? '-blue'
                                            : '-pink'
                                    "
                                ></div>
                            </div>
                        </div>
                    </app-infobulle>
                </div>
            </div>
        </div>
        <div class="calendar" [ngClass]="{ wide: readonly }">
            <div class="loader-wrapper" *ngIf="isLoading">
                <div class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <full-calendar [deepChangeDetection]="true" [options]="calendarOptions" #calendar></full-calendar>
        </div>
    </div>
    <div class="actions" *ngIf="!readonly">
        <p class="error" *ngIf="errorAllDates">{{ 'GARDES.ERROR_ALL_DATES' | translate }}</p>
        <div>
            <button
                (click)="submit()"
                class="btn btn--primary"
                [ngClass]="{ '-saved': isSaved, disabled: errorAllDates || isLoading }"
                [disabled]="isLoading"
            >
                <span *ngIf="isSaved" class="icon i-check"></span>
                <span *ngIf="!isSaved">{{ 'GARDES.SAVE' | translate }}</span>
                <span *ngIf="isSaved">{{ 'GARDES.SAVED' | translate }}</span>
            </button>
            <button (click)="areYouSureToReinitEverything = true" class="btn btn--ternary">{{ 'GARDES.REINIT' | translate }}</button>
        </div>
        <div *ngIf="areYouSureToReinitModif" class="areYouSure">
            <p>{{ 'GARDES.ATTENTION1' | translate }}</p>
            <div>
                <button class="btn btn--no" (click)="reinitModifs()">{{ 'GARDES.BTN3' | translate }}</button>
                <button class="btn btn--yes" (click)="areYouSureToReinitModif = false">{{ 'GARDES.BTN2' | translate }}</button>
            </div>
        </div>
        <div *ngIf="areYouSureToReinitEverything" class="areYouSure">
            <p>{{ 'GARDES.ATTENTION2' | translate }}</p>
            <div>
                <button class="btn btn--no" (click)="reinitCalendar()">{{ 'GARDES.BTN1' | translate }}</button>
                <button class="btn btn--yes" (click)="areYouSureToReinitEverything = false">{{ 'GARDES.BTN4' | translate }}</button>
            </div>
        </div>
    </div>
</div>
